<div class="periodontograma-chart">
  <div class="indices-resumen" *ngIf="indices as ind">
    <div class="indicador" [attr.title]="'sobre ' + ind.sitiosExaminados + ' sitios examinados'">
      <span class="rotulo">Sangrado (BoP)</span>
      <span class="valor" [style.color]="colorBop(ind.bop)">{{ ind.bop !== null ? ind.bop + "%" : "—" }}</span>
    </div>
    <div class="indicador" [attr.title]="'sobre ' + ind.sitiosExaminados + ' sitios examinados'">
      <span class="rotulo">Placa</span>
      <span class="valor">{{ ind.placa !== null ? ind.placa + "%" : "—" }}</span>
    </div>
    <div class="indicador" [attr.title]="'sobre ' + ind.sitiosExaminados + ' sitios examinados'">
      <span class="rotulo">Supuración</span>
      <span class="valor">{{ ind.supuracion !== null ? ind.supuracion + "%" : "—" }}</span>
    </div>
    <div class="indicador">
      <span class="rotulo">Prof. media</span>
      <span class="valor">{{ ind.pdMedia !== null ? ind.pdMedia + " mm" : "—" }}</span>
    </div>
    <div class="indicador">
      <span class="rotulo">Sitios ≥5 mm</span>
      <span class="valor">{{ ind.sitios5mas }}</span>
    </div>
    <div class="indicador">
      <span class="rotulo">Dientes</span>
      <span class="valor">{{ ind.dientesPresentes }}/{{ ind.dientesTotales }}</span>
    </div>
  </div>
  <div class="arcada" *ngFor="let fila of filas">
    <table class="planilla">
      <tr class="fdi-row">
        <th class="rotulo"></th>
        <th
          *ngFor="let fdi of fila"
          class="fdi"
          [class.clickable]="mode === 'edit' && presente(fdi)"
          [class.ausente]="!presente(fdi)"
          (click)="onDiente(fdi)"
        >
          {{ fdi }}
        </th>
      </tr>

      <tr>
        <td class="rotulo">Implante</td>
        <td *ngFor="let fdi of fila">{{ implante(fdi) ? "✓" : "" }}</td>
      </tr>
      <tr>
        <td class="rotulo">Movilidad</td>
        <td *ngFor="let fdi of fila">{{ movilidad(fdi) ?? "" }}</td>
      </tr>
      <tr>
        <td class="rotulo">Pronóstico</td>
        <td *ngFor="let fdi of fila" [style.color]="colorPronostico(fdi)">{{ labelPronostico(fdi) }}</td>
      </tr>
      <tr>
        <td class="rotulo">Furca</td>
        <td *ngFor="let fdi of fila">{{ furca(fdi) ?? "" }}</td>
      </tr>

      <ng-container *ngFor="let cara of caras">
        <tr class="cara-sep">
          <td class="rotulo" [attr.colspan]="fila.length + 1">{{ cara === "vestibular" ? "Vestibular" : "Palatino / Lingual" }}</td>
        </tr>
        <tr>
          <td class="rotulo">Sangrado</td>
          <td *ngFor="let fdi of fila">
            <span *ngFor="let i of [0,1,2]" class="dot" [class.on]="sangrado(fdi, cara, i)" [style.background]="sangrado(fdi, cara, i) ? colorSangrado() : ''"></span>
          </td>
        </tr>
        <tr>
          <td class="rotulo">Sondaje</td>
          <td *ngFor="let fdi of fila">
            <span *ngFor="let i of [0,1,2]" class="num" [style.color]="colorSondaje(fdi, cara, i)">{{ sondaje(fdi, cara, i) ?? "·" }}</span>
          </td>
        </tr>
        <tr>
          <td class="rotulo">Margen</td>
          <td *ngFor="let fdi of fila">
            <span *ngFor="let i of [0,1,2]" class="num">{{ margen(fdi, cara, i) ?? "·" }}</span>
          </td>
        </tr>
        <tr class="nic">
          <td class="rotulo">NIC</td>
          <td *ngFor="let fdi of fila">
            <span *ngFor="let i of [0,1,2]" class="num">{{ nic(fdi, cara, i) ?? "·" }}</span>
          </td>
        </tr>
        <tr>
          <td class="rotulo">Anchura encía</td>
          <td *ngFor="let fdi of fila">{{ anchura(fdi, cara) ?? "" }}</td>
        </tr>
      </ng-container>
    </table>

    <div class="bandas">
      <app-perio-banda
        *ngFor="let cara of caras"
        [fila]="fila"
        [cara]="cara"
        [estado]="estado"
        [odontogramaEstado]="odontogramaEstado"
        [mode]="mode"
        (dienteClick)="onDiente($event.fdi)"
      ></app-perio-banda>
    </div>
  </div>
</div>
